import keymirror from "../utils/keymirror";

export const ViewPostConstants = keymirror(
    {
        FETCH_POST: null,
        FETCH_POST_SUCCESS: null,
        FETCH_POST_FAILURE: null
    },
    "view-post"
);



// WEBPACK FOOTER //
// ./src/constants/viewPost.constants.js